module.exports = __webpack_public_path__ + "static/media/index_bg2.f05fd91b.png";